import { Controller } from 'stimulus';
let debounce = require('lodash/debounce');

export default class extends Controller {
  static targets = ["form", "brands", "models", "caps", "networks"]

  initialize() {
    this.submit = debounce(this.submit, 400).bind(this);
  }
  submit(e) {
    this.formTarget.requestSubmit();
  }
  brandSubmit(e) {
    this.brandsTarget.value = $('#brandsSelect').val().toString();
    this.formTarget.requestSubmit();
    this.populateModels(this.brandsTarget.value);
  }
  modelSubmit(e) {
    this.modelsTarget.value = $('#modelsSelect').val().toString();
    this.formTarget.requestSubmit();
  }
  capSubmit(e) {
    this.capsTarget.value = $('#capsSelect').val().toString();
    this.formTarget.requestSubmit();
  }
  networkSubmit(e) {
    this.networksTarget.value = $('#networksSelect').val().toString();
    this.formTarget.requestSubmit();
  }

  populateModels(brandId) {
    fetch(`models/${brandId}`, {
      credentials: 'same-origin'
    })
      .then(response => response.json())
      .then(data => {
        const selectBox = document.getElementById('modelsSelect');
        selectBox.innerHTML = '';
        data.forEach(item => {
          const opt = document.createElement('option');
          opt.value = item.id;
          opt.innerHTML = item.name;
          selectBox.appendChild(opt);
        });
      });

      this.modelsTarget.value = $('#modelsSelect').val().toString();
  }
} 